import type { VerifyStatus } from "@/types/content";
import { statusMeta } from "@/mocks/site";

const toneMap: Record<VerifyStatus, string> = {
  verified: "bg-accent-100 text-accent-900 border-accent-200",
  pending: "bg-secondary-100 text-secondary-900 border-secondary-200",
  conflict: "bg-primary-100 text-primary-800 border-primary-200",
};

const iconMap: Record<VerifyStatus, string> = {
  verified: "ri-checkbox-circle-line",
  pending: "ri-time-line",
  conflict: "ri-error-warning-line",
};

export default function StatusBadge({
  status,
  size = "md",
}: {
  status: VerifyStatus;
  size?: "sm" | "md";
}) {
  return (
    <span
      title={statusMeta[status].description}
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border font-medium ${toneMap[status]} ${
        size === "sm" ? "px-2 py-0.5 text-[11px]" : "px-2.5 py-1 text-xs"
      }`}
    >
      <span
        className={`flex items-center justify-center ${
          size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5"
        }`}
      >
        <i className={`${iconMap[status]} text-xs`}></i>
      </span>
      {statusMeta[status].label}
    </span>
  );
}